<template>

  <div v-if="this.action === 'changeConsultant'" class="modal fade" :id="modalId" tabindex="-1" role="dialog"
       aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="color-line"></div>
        <div class="modal-header">
          <h4 class="modal-title">Assigned Project To Broker</h4>
        </div>
        <form v-on:submit="changeConsultant" action="#" method="post">
          <div class="modal-body">
            <div class="form-group "
                 v-bind:class="{'has-error' : errorAttachedTo, 'has-success' : errorAttachedTo === false}">
              <label for="attachedTo">Attached To</label>

              <v-select2 id="attachedTo" :options="consultants" label="email" placeholder="Select Attached To"
                        v-model="consultant">
                <input type="hidden" name="attachedToSelectedItem" v-model="consultant.user_id">
                <template slot="option" slot-scope="option">
              <span>
               <b>{{ option.firstname }} {{ option.lastname }}</b><br>
              <small> {{ option.email }}</small>
              </span>

                </template>
              </v-select2>
            </div>

            <div style="text-align: right;margin-top: 10px">
              <span style="font-style: italic;font-size: 12px">(<span
              style="color: red">*</span>) required fields</span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="onCancel">Cancel</button>
            <vue-ladda type="submit" :loading="submitAssignedTo.loading" class="btn btn-info"
                       :data-style="submitAssignedTo.dataStyle">Save
            </vue-ladda>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>

import vSelect2 from '../../components/utils/select2'
import axios from 'axios'
import VueLadda from 'vue-ladda'

export default {
  components: {
    VueLadda,
    vSelect2
  },
  props: ['project', 'refresh', 'action', 'showModal', 'onAssignedToConsultantAction', 'consultants'],
  name: 'ActionAssignedToConsultant',
  watch: {
    project: function (val) {
      this.consultant = (this.project && this.project.question && this.project.question.consultant) ? this.project.question.consultant : {
        'user_id': 0,
        'email': 'No broker Selected'
      }
    }
  },
  methods: {
    changeConsultant: function (event) {
      this.submitAssignedTo.loading = true

      if (this.project.question !== null) {
        axios.patch('/question/' + this.project.question.id + '/consultant', {
          consultant_id: this.consultant.user_id
        }).then((response) => {
          this.onAssignedToConsultantAction(null, null, null)
          this.submitAssignedTo.loading = false
          $('#' + this.modalId + '').modal('toggle')
          this.errorAttachedTo = null
          this.refresh = true
        })
          .catch((error) => {
            if (error.response.status === 400) {
              let errors = error.response.data.errors
              switch (error.response.data.code) {
                case 1:
                  this.errorAttachedTo = errors['attachedTo'][0]
                  break
              }
            }
            this.submitAssignedTo.loading = false
          })
      }
      event.preventDefault()
    },
    init: function () {
      switch (this.action) {
        case 'changeConsultant' :
          this.modalId = 'changeConsultant'
          break
      }
    },
    onCancel: function () {
      this.onAssignedToConsultantAction(null, null, null)
    }
  },
  updated () {
    let modalId

    if (this.showModal === true) {
      modalId = this.action

      $('#' + modalId).modal()
      $('#' + modalId).on('hidden.bs.modal', (e) => {
        this.onAssignedToConsultantAction(null, null, null)
      })
    }
  },
  mounted () {
  },
  data () {
    return {
      consultant_id: null,
      errorAttachedTo: null,
      consultant: {'user_id': 0, 'email': 'No broker Selected'},
      submitAssignedTo: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      modalId: null
    }
  },
  beforeUpdate () {
    this.init()
  },
  beforeMount () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/ActionModalAssignedToConsultant.vue